module.exports = __webpack_public_path__ + "media/images/sp/specials/fair/raiten-tokuten-5190dc7eca2b00aa457c725fd15e20e3.png";